import React from 'react';

export default function RoleManagement() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Role Management</h1>
      <p className="text-gray-500">Halaman Role Management</p>
    </div>
  );
}
